import React, { useContext, useEffect } from "react";
import { AppContext } from "../States/AppContext";
import { Link, useNavigate } from "react-router-dom";

//styles
import {
  SkClose,
  SkTopLine,
  SkBox,
  SkboxItem,
  SkboxTitle,
  SkIconWrapper,
  SkWrapper,
} from "./SmartKeyBox.elements";

//icons & images
import { AiFillLock } from "react-icons/ai";
import { AiOutlineClose } from "react-icons/ai";
import alarmcomma from "../../img/icons/alarmcomma.png";
import spo2img from "../../img/icons/spo2.png";


//data
// import { skButtons } from "../../Data";
// 7.19 added smartkeys to statedata. keep for now in case there are any issues that come with this 

const SmartKeyBox = () => {
  const navigate = useNavigate();

  const { state, setState } = useContext(AppContext);

  const smartKeys = state.skButtons.map((btn) => {
    return (
      <Link
        to={
          btn.name === "/lock"
            ? "/"
            : btn.name === "/spo2" && !state.isLocked
            ? "/"
            : btn.name === "/ecg" && state.ecg === false
            ? "#"
            : state.isLocked
            ? "#"
            : `${btn.name}`
        }
        onClick={(e) => {
          if (btn.name === "/spo2" && !state.isLocked) {
            if (state.spoContinuous === false) {
              setState((prevState) => ({
                ...prevState,
                initiateSpo2start: true,
                spoStart: false,
                currentPageIndex: 0,
              }));
              navigate("/", { replace: true });
            } else {
              e.preventDefault();
              // Handle the case when state.spoContinuous is true
              // You can add your desired code here
            }
          } else if (btn.name === "/lock") {
            {
              state.isLocked &&
                setState((prevState) => ({
                  ...prevState,
                  isLockEnterPw: true,
                  currentPageIndex: 0,
                  isButtonPressed: true,
                  lockScreenIndex:1,
                  isLocked:true,
                }));
            }

            {
              !state.isLocked &&
                setState((prevState) => ({
                  ...prevState,
                  isLocked: true,
                  currentPageIndex: 0,
                }));
            }
          } else if (btn.name === "/ecg" && state.ecg === false) {
            setState((prevState) => ({
              ...prevState,
              ecg: true,
              ecgOffWave1: false,
              ecgOffWave2: false,
            }));
          }
        }}
        disabled={state.isLocked}
        key={btn.id}
      >
        <SkboxItem>
          <SkIconWrapper>

            {btn.name === "/lock" && state.isLocked ? (
              <AiFillLock />
            ) : btn.name === "/ecg" && !state.ecg ? (
              <div
                style={{
                  position: "relative",
                  display: "inline-block",
                }}
              >
                <btn.icon />
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%) rotate(45deg)",
                    width: "150%",
                    height: "2px",
                    backgroundColor: "#caceca",
                  }}
                ></div>
              </div>
            ) : btn.name === "/spo2" && state.spoContinuous ? (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  height: "37px",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "auto",
                  gap: ".1em",
                  cursor: "not-allowed",
                }}
              >
                <img
                  src={spo2img}
                  style={{
                    height: "35px",
                    padding: "0",
                    width: "auto",
                    filter: "grayscale(100%) brightness(50%)",
                  }}
                ></img>
              </div>
            ) : btn.name === "/settings/alarms" ? (
              <div style={{ position: "relative" }}>
                <btn.icon />
                <img
                  src={alarmcomma}
                  alt=""
                  style={{
                    position: "absolute",
                    top: "10%",
                    height: "35%",
                    right: "-12px",
                  }}
                />
              </div>
            ) : btn.name === "/settings/opmodes" ? (
              <div style={{ transform: "scaleX(-1)" }}>
                <btn.icon />
              
              </div>
            ) : (
              <btn.icon />
            )}
          </SkIconWrapper>

          <SkboxTitle>
            {btn.name === "/lock" && state.isLocked ? (
              "Lock: On"
            ) : btn.name === "/ecg" && !state.ecg ? (
              "ECG: Off"
            ) : btn.name === "/spo2" && state.spoContinuous ? (
              <div style={{ color: "gray" }}>{btn.title}</div>
            ) : (
              btn.title
            )}
          </SkboxTitle>
        </SkboxItem>
      </Link>
    );
  });

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        window.scrollTo(0, element.offsetTop);
      }
    }
  }, []);

  return (
    <>
      <SkWrapper>
        <SkTopLine>
          SmartKeys
          <Link to="/">
            <SkClose>
              <AiOutlineClose></AiOutlineClose>
            </SkClose>
          </Link>
        </SkTopLine>
        <SkBox>{smartKeys}</SkBox>
      </SkWrapper>
    </>
  );
};

export default SmartKeyBox;
